const client = {
    clientId: '',
    clientSecret: ''
};

export const ClientEncoded = window.btoa(client.clientId + ':' + client.clientSecret);
